<table edsCol class="table table--secondary">
  <tbody class="table__body">
    <tr class="table__tr">
      <td
        class="table__td text-align-left"
        *ngFor="let header of tableData?.headers"
      >
        {{ header }}
      </td>
    </tr>
    <tr class="table__tr" *ngFor="let rowData of tableBody">
      <td
        class="table__td text-align-left"
        *ngFor="let colData of rowData; let i = index"
      >
        <span *ngIf="i === 0">{{ colData }}</span>
        <span *ngIf="i !== 0">{{ colData | number: "1.2-2":"de-DE" }}</span>
      </td>
    </tr>
  </tbody>
</table>

<eds-pagination
  *ngIf="totalPageCount > 1"
  [pages]="totalPageCount"
  (pageChanged)="onPageChanged($event)"
  [prevPageText]="prevPageText"
  [nextPageText]="nextPageText"
  [ariaLabelGoToPage]="ariaLabelGoToPage"
></eds-pagination>
